/* Search app theme glue.

   VENDOR FILE, MODIFIED. The app installed this; if it ever rewrites the file
   these guards go with it, so re-apply them and keep this note.

   What changed: null guards, nothing else. Every selector below was being
   dereferenced without checking it matched, so a missing element threw and
   killed the rest of the handler. The live symptom was this on every page load:

     TypeError: Cannot read properties of null (reading 'addEventListener')
       at sq-theme.js:1:433

   That came from getElementById("Search-In-Modal"), an element this theme does
   not have anywhere. The throw happened inside the window load handler, so
   anything after it in that handler never ran.

   The same pattern existed in four more places: the three filter toggles read
   .sq-filter-main, the focus handlers read .sq-dropdown-body, and the Escape
   handler clicked document.querySelector("footer"). All are now checked.

   Behaviour is otherwise identical. toggleFilter, toggleClass and removeClass
   stay global function declarations because markup calls them from inline
   handlers, and window.sq.initSearch stays because sq-app.min.js calls it. */

function toggleFilter() {
    var x = document.querySelector(".sq-filter-main");
    if (x) x.classList.toggle("opening");
}
function toggleClass() {
    var y = document.querySelector(".sq-filter-main");
    if (y) y.classList.remove("opening");
}
function removeClass() {
    var z = document.querySelector(".sq-filter-main");
    if (z) z.classList.remove("opening");
}

window.sq = window.sq || {};

window.addEventListener("load", () => {
    if (!window.matchMedia("(max-width: 767px)").matches) return;

    var input = document.getElementById("Search-In-Modal");
    if (!input) return;

    var setBodyHeight = function (value) {
        var body = document.querySelector(".sq-dropdown-body");
        if (body) body.style.maxHeight = value;
    };

    input.addEventListener("focusin", function () { setBodyHeight("100%"); });
    input.addEventListener("focusout", function () { setBodyHeight("0px"); });
});

window.sq.initSearch = (store) => {
    store.search();
};

setTimeout(function () {
    var filter = document.querySelector(".sq-filter-main");
    if (filter) filter.style.visibility = null;
    var container = document.querySelector(".sparq-container");
    if (container) container.style.visibility = null;
}, 200);

window.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    var footer = document.querySelector("footer");
    if (footer) footer.click();
});
